export default {
  loginWithEmailAlert: "/email/loginWithEmailAlert",
};
